import { isPresent } from "neetocist";
import { prop, pipe } from "ramda";

import { ICONS_MAP, INTEGER, PHONE_NUMBER } from "./constants";

export const getInputType = ({ name, kind }) => {
  if (name === PHONE_NUMBER) return "tel";
  else if (kind === INTEGER) return "number";

  return "text";
};

export const getIcon = ({ iconSize, name, value }) => {
  const Icon =
    name === "browser" || name === "os"
      ? ICONS_MAP[value?.toLowerCase().replace(" ", "_")]
      : ICONS_MAP[name];

  return isPresent(Icon) ? <Icon size={iconSize} /> : null;
};

export const isValuePresent = pipe(prop("value"), isPresent);

export const mergeRefs =
  (...refs) =>
  node =>
    refs
      .filter(Boolean)
      .forEach(ref =>
        typeof ref === "function" ? ref(node) : (ref.current = node)
      );
